<div class="coworking-detail-container" *ngIf="coworkingInfo">
  <div class="header">
    <div class="back">
      <cowing-back-button [previous]="this.previous"></cowing-back-button>
    </div>
    <div class="title">
      {{ coworkingInfo.company_name }}
    </div>
  </div>
  <div class="card">
    <ng-image-slider [imageSize]="{ width: '100%', height: '30%' }" [images]="mediaObject" [manageImageRatio]="'true'"
      #nav></ng-image-slider>
  </div>
  <div class="title">
    <div class="address">
      {{ coworkingInfo.fiscal_address }}
    </div>
    <div class="location">
      <cowing-button
        [label]="'coworking.general.view-location' | translate"
        [type]="EButtonType.Outline"
        [iconShow]="true"
        [iconName]="'arrowRightGreen'"
        (event)="goToMap()"
      >
      </cowing-button>
    </div>
  </div>
  <div class="description">
    <div>
      {{ coworkingInfo.description }}
    </div>
  </div>
  <div class="services">
    <div class="header">
      <div class="title">{{ "coworking.services.essentials" | translate }}</div>
    </div>
    <div class="content">
      <cowing-essential-service *ngFor="let service of essentialsServices" [isForm]="false" [label]="service.label"
        [icon_url]="service.icon_url"></cowing-essential-service>
    </div>
  </div>

  <div class="schedule">
    <div class="header">
      <div class="title">
        {{ "coworker.coworking-detail.schedule" | translate }}
      </div>
    </div>
    <div class="content">
      <cowing-element *ngFor="let schedule of coworkingInfo.hours; let i = index" [label]="schedule" [index]="i"
        [schedule]="'schedule'">
      </cowing-element>
    </div>
  </div>

  <div class="spaces">
    <div class="header">
      <div class="title">
        {{ "coworker.coworking-detail.spaces" | translate }}
      </div>
    </div>
    <div class="content">
      <coworking-space-card *ngFor="let space of coworkingSpaces" [space]="space">
      </coworking-space-card>
    </div>
  </div>
  <div class="others">
    <div class="header">
      <div class="title">
        {{ "coworker.coworking-detail.extras" | translate }}
      </div>
    </div>
    <div class="content-others">
      <span *ngFor="let services of othersServices; let i = index">
        {{
          i !== othersServices.length - 1
            ? services.label + ", "
            : services.label
        }}
      </span>
    </div>
  </div>

  <div class="actions-section" *ngIf="coworkingInfo">
    <div class="coworking-info">
      <div class="name">{{ coworkingInfo.company_name }}</div>
      <div class="price">
        <span>
          {{ "coworker.home.card.from" | translate }}
          {{ coworkingInfo.min_price }} C
        </span>
        <span *ngIf="coworkingInfo?.min_price_type == 1">
          / {{ "coworker.home.card.hour" | translate }}
        </span>
        <span *ngIf="coworkingInfo?.min_price_type == 3">
          / {{ "coworker.home.card.day" | translate }}
        </span>
        <span *ngIf="coworkingInfo?.min_price_type == 4">
          / {{ "coworker.home.card.week" | translate }}
        </span>
        <span *ngIf="coworkingInfo?.min_price_type == 5">
          / {{ "coworker.home.card.month" | translate }}
        </span>
      </div>
    </div>
    <div>
      <cowing-button [label]="'coworker.coworking-detail.reservation-action' | translate" [type]="EButtonType.Rounded"
        [iconShow]="false" (event)="goBooking()">
      </cowing-button>
    </div>
  </div>
</div>
